import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const useAddEdit = () => {
  const navigate = useNavigate();
  const { action, id } = useParams();
  const location = useLocation();
  const isEdit = action == routes.edit;
  const isView = action == routes.view;

  const pathParts = location.pathname.split("/");
  const actionIndex = pathParts.indexOf(action || "");
  const activeTab = pathParts[actionIndex + 1] || routes.projectInfo;

  const projectData = useSelector(
    (state: RootState) => state.currentData.projectData
  );
  
  const onBackClick = () => {
    navigate(`/${routes.pm}/${routes.projectOverview}`);
  };

  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.pm}/${routes.projectOverview}`,
        name: `Project Overview`,
      },
      {
        link: "",
        name:
          isEdit || isView
            ? `${projectData?.name} Project Details`
            : "Add Project",
      },
    ],
    [projectData]
  );

  return {
    breadcrumbData,
    onBackClick,
    navigate,
    action,
    id,
    activeTab,
  };
};

export default useAddEdit;
